import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import CasinoLogoContent from './CasinoLogoContent';

export default function CasinoLogo() {
  return (
    <CasinoContainer title={'Casino logo'}>
      <CasinoLogoContent />
    </CasinoContainer>
  );
}
